<template>
  <!-- Start Main Banner -->
  <div class="main-banner">
    <div class="d-table">
      <div class="d-table-cell">
        <div class="container">
          <div class="row h-100 justify-content-center align-items-center">
            <div class="col-lg-5">
              <div class="hero-content">
                <h1>{{ t('atonline_main_title') }}</h1>
                <p>{{ t('atonline_main_desc') }}</p>
                
                <a href="https://drive.atonline.com" class="btn btn-primary" target="_blank">{{ t('get_started') }}</a>
              </div>
            </div>

            <div class="col-lg-6 offset-lg-1">
              <div class="banner-image">
                <img src="/img/banner-image/man.png" class="wow fadeInDown" data-wow-delay="0.6s" alt="man">
                <img src="/img/banner-image/code.png" class="wow fadeInUp" data-wow-delay="0.6s" alt="code">
                <img src="/img/banner-image/carpet.png" class="wow fadeInLeft" data-wow-delay="0.6s" alt="carpet">
                <img src="/img/banner-image/bin.png" class="wow zoomIn" data-wow-delay="0.6s" alt="bin">
                <img src="/img/banner-image/book.png" class="wow bounceIn" data-wow-delay="0.6s" alt="book">
                <img src="/img/banner-image/dekstop.png" class="wow fadeInDown" data-wow-delay="0.6s" alt="dekstop">
                <img src="/img/banner-image/dot.png" class="wow zoomIn" data-wow-delay="0.6s" alt="dot">
                <img src="/img/banner-image/flower-top-big.png" class="wow fadeInUp" data-wow-delay="0.6s" alt="flower-top-big">
                <img src="/img/banner-image/flower-top.png" class="wow rotateIn" data-wow-delay="0.6s" alt="flower-top">
                <img src="/img/banner-image/keyboard.png" class="wow fadeInUp" data-wow-delay="0.6s" alt="keyboard">
                <img src="/img/banner-image/pen.png" class="wow zoomIn" data-wow-delay="0.6s" alt="pen">
                <img src="/img/banner-image/table.png" class="wow zoomIn" data-wow-delay="0.6s" alt="table">
                <img src="/img/banner-image/tea-cup.png" class="wow fadeInLeft" data-wow-delay="0.6s" alt="tea-cup">
                <img src="/img/banner-image/headphone.png" class="wow rollIn" data-wow-delay="0.6s" alt="headphone">

                <img src="/img/banner-image/main-pic.png" class="wow fadeInUp" data-wow-delay="0.6s" alt="main-pic">
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="shape1"><img src="/img/shape1.png" alt="shape"></div>
    <div class="shape2 rotateme"><img src="/img/shape2.svg" alt="shape"></div>
    <div class="shape3"><img src="/img/shape3.svg" alt="shape"></div>
    <div class="shape4"><img src="/img/shape4.svg" alt="shape"></div>
    <div class="shape5"><img src="/img/shape5.png" alt="shape"></div>
    <div class="shape6 rotateme"><img src="/img/shape4.svg" alt="shape"></div>
    <div class="shape7"><img src="/img/shape4.svg" alt="shape"></div>
    <div class="shape8 rotateme"><img src="/img/shape2.svg" alt="shape"></div>
  </div>
  <!-- End Main Banner -->
</template>

<script>
import i18next from '../i18next.js'

export default {
  name: 'MainBanner',
  setup() {
    // Simple translation function
    const t = (key) => i18next.t(key);
    
    return { t }
  }
}
</script>

<style scoped>
/* Banner styling is handled in the imported CSS */
</style>